@if (runState() === 'running') {
  <tellent-assistant-tool-pill class="pill" [toolName]="currentToolName()" />
} @else if (stepCount() > 0) {
  <rt-button
    class="summary"
    [class.summary--expanded]="expanded()"
    variant="plain"
    size="small"
    (click)="toggle()"
  >
    <rt-icon class="chev" name="expand-more" />
    <span>{{
      'tlc.tellent_assistant.tool_call.steps_completed' | translate: { count: stepCount() }
    }}</span>
  </rt-button>
}

@if (expanded() && hasContent()) {
  <div class="timeline">
    @for (event of timeline(); track $index) {
      @if (event.kind === 'reasoning') {
        <p class="reasoning">{{ event.content }}</p>
      } @else {
        <div [class.row--error]="event.status === 'error'" class="row">
          <span class="num">{{ event.stepNumber }}.</span>
          <span class="name">{{ event.name }}</span>
          @if (event.status === 'error') {
            <rt-icon class="err" name="error" />
          }
        </div>
      }
    }
  </div>
}
